<template>
  <section class="page-section">
        <el-tabs v-model="tabName" type="card" @tab-click="handleTabsChange">
          <el-tab-pane label="未上线" name="0"></el-tab-pane>
          <el-tab-pane label="上线中" name="1"></el-tab-pane>
          <el-tab-pane label="已下线" name="2"></el-tab-pane>
          <el-tab-pane label="已过期" name="3"></el-tab-pane>
        </el-tabs>

        <!-- filter -->
        <div class="filter-region">
          <div class="filter-form">
            <el-form size="small" :inline="true" :model="filterForm" ref="filterForm">
              <el-form-item label="兑换券名称：" prop="name">
                <el-input v-model="filterForm.name" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="类型：" prop="type">
                <el-select v-model="filterForm.type" placeholder="请选择">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="现金券" value="3"></el-option>
                  <el-option label="商品券" value="4"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div class="filter-btn">
            <el-button-group class="btn-group">
              <el-button plain class="btn-reset" icon="el-icon-refresh"
                @click="filterFormReset('filterForm')"></el-button>
              <el-button type="primary" class="btn-search" @click="filterFormSubmit('filterForm')"
                :loading="tableLoading">查询</el-button>
            </el-button-group>
          </div>
        </div>

        <el-button type="primary" class="btn-add-block" @click="pageNavigateToMarketingCouponAdd">新建兑换券</el-button>

        <!-- table -->
        <div class="table-region" v-loading="tableLoading">
          <el-table size="small" :data="tableData" ref="multipleTable" :row-class-name="tableRowClassName"
            @selection-change="handleTableSelectionChange">
            <el-table-column type="selection" width="42" v-if="tabName != '3'"></el-table-column>
            <el-table-column label="名称">
              <template slot-scope="scope">
                <p>{{ scope.row.name }}</p>
              </template>
            </el-table-column>
            <el-table-column label="类型">
              <template slot-scope="scope">
                <p v-if="scope.row.type == 3">现金券</p>
                <p v-if="scope.row.type == 4">商品券</p>
              </template>
            </el-table-column>
            <el-table-column label="使用门槛">
              <template slot-scope="scope">
                <p>{{ scope.row.threshold }}</p>
              </template>
            </el-table-column>
            <el-table-column label="兑换内容">
              <template slot-scope="scope">
                <p>{{ scope.row.exchangeContent }}</p>
              </template>
            </el-table-column>
            <el-table-column label="发放总量">
              <template slot-scope="scope">
                <p>{{ scope.row.putInLimit }}</p>
              </template>
            </el-table-column>
            <el-table-column label="已领取">
              <template slot-scope="scope">
                <!-- <p v-if="scope.row.getNum"><router-link class="router-link-active" :to="{ path: '/marketing/coupon/detail', query: { id: scope.row.id }}">{{ scope.row.getNum }}</router-link></p>
                                <p v-else>-</p> -->
                <p>{{ scope.row.getNum || '-' }}</p>
              </template>
            </el-table-column>
            <el-table-column label="已使用">
              <template slot-scope="scope">
                <p>{{ scope.row.useNum || '-' }}</p>
              </template>
            </el-table-column>
            <el-table-column label="未使用">
              <template slot-scope="scope">
                <p>{{ scope.row.unuseNum || '-' }}</p>
              </template>
            </el-table-column>
            <el-table-column label="已过期">
              <template slot-scope="scope">
                <p>{{ scope.row.expireNum || '-' }}</p>
              </template>
            </el-table-column>
            <el-table-column label="最后编辑时间">
              <template slot-scope="scope">
                <p>{{ scope.row.time || '-' }}</p>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="right">
              <template slot-scope="scope">

                <!-- 上线 -->
                <el-popover placement="top" width="165" v-model="scope.row.upVisible" popper-class="confirm-popover"
                  v-if="((tabName == '0' && scope.row.getTimeType == 0) || tabName == '2') && !tableLoading">
                  <p>确定上线该兑换券？</p>
                  <div>
                    <el-button size="small" type="default" plain
                      @click="handleChangeCancle(scope.row, scope.$index)">取消</el-button>
                    <el-button size="small" type="primary" @click="handleChangeStatus(scope.row, scope.$index, '1')"
                      :loading="scope.row.changeLoading">确定</el-button>
                  </div>

                  <el-button size="small" type="text" slot="reference">上线</el-button>
                </el-popover>

                <!-- 下线 -->
                <el-popover placement="top" width="165" v-model="scope.row.downVisible" popper-class="confirm-popover"
                  v-if="tabName == '1' && !tableLoading">
                  <p>下线后，买家之前领取的兑换券，在可用时间内还能继续使用。确定下线？？</p>
                  <div>
                    <el-button size="small" type="default" plain
                      @click="handleChangeCancle(scope.row, scope.$index)">取消</el-button>
                    <el-button size="small" type="primary" @click="handleChangeStatus(scope.row, scope.$index, '2')"
                      :loading="scope.row.changeLoading">确定</el-button>
                  </div>

                  <el-button size="small" type="text" slot="reference">下线</el-button>
                </el-popover>

                <!-- <el-button size="small" type="text" @click="handleChangeStatus(scope.row, '1')">上线</el-button> -->
                <!-- <el-button size="small" type="text" @click="handleChangeStatus(scope.row, '2')">下线</el-button> -->
                <el-button size="small" type="text" @click="pageNavigateToMarketingCouponAdd(scope.row)"
                  v-if="tabName != '3' && scope.row.canUpdate">编辑</el-button>
                <el-button size="small" type="text" @click="pageNavigateToMarketingCouponDetail(scope.row)"
                  v-if="tabName != '0'">领取详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="table-footer" v-if="page.total > 0">
          <div class="selection-operate">
            <el-checkbox v-model="allSelect" @change="handleAllSelectChange" v-if="tabName != '3'">全选当页</el-checkbox>

            <div class="button-wrap">
              <!-- 上线 -->
              <el-popover placement="top" width="165" v-model="operate.upVisible" popper-class="confirm-popover"
                v-if="(tabName == '0' || tabName == '2') && showOnline">
                <p>确定上线所选兑换券？</p>
                <div>
                  <el-button size="small" type="default" plain @click="handleOperateCancle">取消</el-button>
                  <el-button size="small" type="primary" @click="handleUpdateStatus('1')"
                    :loading="operateLoading">确定</el-button>
                </div>

                <el-button size="small" type="default" plain slot="reference">上线</el-button>
              </el-popover>

              <!-- 下线 -->
              <el-popover placement="top" width="165" v-model="operate.downVisible" popper-class="confirm-popover"
                v-if="tabName == '1'">
                <p>下线后，买家之前领取的兑换券，在可用时间内还能继续使用。确定下线？？</p>
                <div>
                  <el-button size="small" type="default" plain @click="handleOperateCancle">取消</el-button>
                  <el-button size="small" type="primary" @click="handleUpdateStatus('2')"
                    :loading="operateLoading">确定</el-button>
                </div>

                <el-button size="small" type="default" plain slot="reference">下线</el-button>
              </el-popover>
            </div>
          </div>

          <div class="pagination-wrap">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :page-sizes="[20, 50, 100]" :pager-count="5" :current-page="page.current" :page-size="page.size"
              layout="total, sizes, prev, pager, next, jumper" :total="page.total">
            </el-pagination>
          </div>
        </div>

      </section>
</template>

<script>
import { COMMON, couponList, couponChangeStatus } from '@/common/api'

export default {
  name: 'goodsManageList',
  data() {
    return {
      tabName: '0', //选项卡name

      filterForm: { //筛选表单值
        name: '', // 优惠券名称
        type: '' // 优惠券类型
      },

      tableLoading: true,
      tableData: [], //表格数据
      page: {
        current: 1,
        size: 20,
        total: 0
      },

      multipleSelection: [], // 选中的数据
      allSelect: false, //全选当页
      showOnline: false, // 是否显示底部上线按钮
      operate: {
        upVisible: false, // 上架
        downVisible: false, // 下架
        deleteVisible: false // 删除
      },
      operateLoading: false
    }
  },
  methods: {
    /**
     * [handleTabsChange description] 切换选项卡
     * @param  {[type]} tab   [description] 取name值用tab.name
     * @param  {[type]} event [description]
     * @return {[type]}       [description]
     */
    handleTabsChange: function (tab, event) {
      // 初始化状态
      this.filterForm = {
        name: '',
        type: ''
      };

      this.page.current = 1;
      this.multipleSelection = [];
      this.allSelect = false;
      this.handleOperateCancle();

      this.getList();
    },
    /**
     * [getList description] 获取表格数据
     * @return {[type]} [description]
     */
    getList: function () {
      this.tableLoading = true;

      let params = {
        couponType: 2, // 1 优惠券 2 兑换券
        status: parseFloat(this.tabName),
        name: this.filterForm.name,
        pageNo: this.page.current,
        pageSize: this.page.size
      }
      if (this.filterForm.type) {
        params.type = this.filterForm.type
      }

      couponList(params).then(res => {
        this.tableLoading = false;

        let { code, data, msg } = res;

        if (code == 0) {
          let dataArray = data.records || [];

          this.tableData = dataArray;
          this.page.total = data.total;

          this.handleCheckOnlineStauts();
          this.$nextTick(() => {
            const scrollContainer = document.querySelector('.app-container');
            if (scrollContainer) {
              scrollContainer.scrollTop = 0;
            }
          });
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
      });
    },
    /**
     * [handleSizeChange description] 分页每页条数变化
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleSizeChange(val) {
      this.page.current = 1;
      this.page.size = val;
      this.getList();
    },
    /**
     * [handleCurrentChange description] 选择分页第几页
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleCurrentChange(val) {
      this.page.current = val;
      this.getList();
    },
    /**
     * [filterFormSubmit description] 提交筛选表单
     * @param  {[type]} formName [description]
     * @return {[type]}          [description]
     */
    filterFormSubmit: function (formName) {
      this.page.current = 1;

      this.getList();
    },
    /**
     * [filterFormReset description] 重置筛选表单
     * @param  {[type]} formName [description]
     * @return {[type]}          [description]
     */
    filterFormReset: function (formName) {
      this.$refs[formName].resetFields();
    },
    /**
     * [handleCheckOnlineStauts description]
     * @return {[type]} [description]
     */
    handleCheckOnlineStauts: function () {
      if (this.tableData.length > 0) {
        for (let i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].getTimeType == 0) {
            this.showOnline = true;
            break;
          }
        }
      }
    },
    /**
     * [handleTableSelectionChange description] table筛选选中状态变化
     * @param  {[type]} val [description] 选中行的数据集合array
     * @return {[type]}     [description]
     */
    handleTableSelectionChange: function (val) {
      if (val.length < this.tableData.length) {
        // 未全选中，改变底部全选状态
        this.allSelect = false;
      } else {
        this.allSelect = true;
      }

      this.multipleSelection = val;
    },
    /**
     * [handleAllSelectChange description] 全选
     * @param  {[type]} selected [description]
     * @return {[type]}          [description]
     */
    handleAllSelectChange: function (selected) {
      this.$refs.multipleTable.toggleAllSelection();
    },
    /**
     * [tableRowClassName description]
     * @param  {[type]} options.row      [description]
     * @param  {[type]} options.rowIndex [description]
     * @return {[type]}                  [description]
     */
    tableRowClassName: function ({ row, rowIndex }) {
      if (this.tabName == '0' && row.getTimeType == 1) {
        return 'no-selection';
      }

      return '';
    },
    /**
     * [handleOperateCancle description] 操作popover - 取消
     * @return {[type]} [description]
     */
    handleOperateCancle: function () {
      this.operate = {
        upVisible: false,
        downVisible: false,
        deleteVisible: false
      }
    },
    /**
     * [handleChangeCancle description] 单个商品上下线 - 取消
     * @param  {[type]} row   [description]
     * @param  {[type]} index [description]
     * @return {[type]}       [description]
     */
    handleChangeCancle: function (row, index) {
      row.upVisible = false;
      row.downVisible = false;
      row.changeLoading = false;

      this.$set(this.tableData, index, row);
    },
    /**
     * [handleChangeStatus description] 单个商品上下线 - ok
     * @param  {[type]} row   [description]
     * @param  {[type]} index [description]
     * @return {[type]}       [description]
     */
    handleChangeStatus: function (row, index, status) {
      let statusName = '';
      if (status == '1') {
        statusName = '上线';
      } else if (status == '2') {
        statusName = '下线';
      }

      row.changeLoading = true;
      this.$set(this.tableData, index, row);

      let params = {
        list: [row.id].join(','),
        status: status
      }

      couponChangeStatus(params).then(res => {
        row.changeLoading = false;

        let { code, data, msg } = res;

        if (code == 0) {
          this.$message({ message: statusName + '成功', type: 'success' });
          this.multipleSelection = [];
          this.handleOperateCancle();
          this.getList();
        } else {
          this.$message.error(msg);
        }

        this.$set(this.tableData, index, row);
      }).catch(error => {
        row.changeLoading = false;
        this.$set(this.tableData, index, row);
        this.$message.error('服务器异常');
      });
    },
    /**
     * [handleUpdateStatus description] 多选商品上下线
     * @param  {[type]} status [description]
     * @return {[type]}        [description]
     */
    handleUpdateStatus: function (status) {
      let statusName = '';
      if (status == '1') {
        statusName = '上线';
      } else if (status == '2') {
        statusName = '下线';
      }

      if (this.multipleSelection.length == 0) {
        this.$message.error('请选择需要' + statusName + '的兑换券');
        this.handleOperateCancle();
        return false;
      }

      this.operateLoading = true;

      let ids = [];
      for (let i = 0; i < this.multipleSelection.length; i++) {
        if (this.tabName == '0' && this.multipleSelection[i].getTimeType == '1') {

        } else {
          ids.push(this.multipleSelection[i].id);
        }
      }

      let params = {
        list: ids.join(','),
        status: status
      }

      couponChangeStatus(params).then(res => {
        this.operateLoading = false;

        let { code, data, msg } = res;

        if (code == 0) {
          this.$message({ message: statusName + '成功', type: 'success' });
          this.multipleSelection = [];
          this.handleOperateCancle();
          this.getList();
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.operateLoading = false;
        this.$message.error('服务器异常');
      });
    },
    /**
     * [pageNavigateToMarketingCouponAdd description] 跳转到新建优惠券页面
     * @return {[type]} [description]
     */
    pageNavigateToMarketingCouponAdd: function (row) {
      if (row) {
        this.$router.push({ path: '/marketing/coupon/exchange/add', query: { id: row.id } });
      } else {
        this.$router.push({ path: '/marketing/coupon/exchange/add' });
      }
    },
    /**
     * [pageNavigateToMarketingCouponDetail description] 跳转到优惠券详情页面
     * @return {[type]} [description]
     */
    pageNavigateToMarketingCouponDetail: function (row) {
      if (row) {
        this.$router.push({ path: '/marketing/coupon/exchange/detail', query: { id: row.id } });
      }
    }
  },
  mounted() {
    this.getList();
  }
}
</script>

<style lang="scss" scoped>
@import "../../../common/styles/base/mixin-font";
@import "../../../common/styles/base/mixin-common";

.button-edit {
  display: none;
}

.el-table__row {
  &:hover {
    .button-edit {
      display: inline-block;
      padding-top: 0;
      padding-bottom: 0;
    }
  }
}

::v-deep .no-selection .el-checkbox {
  display: none;
}

.filter-region {
  flex-shrink: 0; // 筛选区域不压缩
  display: flex;
  align-items: center;

  .filter-form {
    flex: 1;
  }

  .filter-btn {
    height: 100%;

    .btn-group {
      display: flex;

      .btn-reset {
        width: 40px;
        height: 40px;
        border-color: #3388ff;
        color: #3388ff;
      }

      .btn-search {
        width: 84px;
        height: 40px;
      }

      .el-button {
        &+.el-button {
          margin-left: -1px !important;
        }

        &:first-child {
          border-top-right-radius: 0 !important;
          border-bottom-right-radius: 0 !important;
        }

        &:last-child {
          border-top-left-radius: 0 !important;
          border-bottom-left-radius: 0 !important;
        }
      }
    }
  }
}

.table-region {
  margin-bottom: 50px;
}
</style>
